import { UserService } from '~/lib/services/user-service'
import { defineServiceComposable } from '~/composables/service-container'

export const useUserService = defineServiceComposable(
  'user',
  () =>
    new UserService({
      apiService: useApiService(),
      clientCookieService: useClientCookieService(),
    }),
)
